(function () {
  function init() {
    var grid = document.getElementById('product-grid');
    var sentinel = document.querySelector('[data-eatguud-infinite-sentinel]');
    if (!grid || !sentinel || sentinel.dataset.eatguudInitialized) return;
    sentinel.dataset.eatguudInitialized = 'true';

    var spinner = sentinel.querySelector('[data-eatguud-infinite-spinner]');
    var sectionId = grid.getAttribute('data-id');
    var loading = false;

    function loadNext() {
      var nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl || loading) return;
      loading = true;
      if (spinner) spinner.hidden = false;

      var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
      var url = nextUrl + separator + 'section_id=' + sectionId;

      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var newSentinel = doc.querySelector('[data-eatguud-infinite-sentinel]');

          if (newGrid) {
            Array.from(newGrid.children).forEach(function (child) {
              grid.appendChild(child);
            });
          }

          var newNextUrl = newSentinel ? newSentinel.getAttribute('data-next-url') : '';
          sentinel.setAttribute('data-next-url', newNextUrl || '');
          if (!newNextUrl) {
            observer.unobserve(sentinel);
          }

          if (typeof window.eatguudReapplyMealFilter === 'function') {
            window.eatguudReapplyMealFilter();
          }
          if (typeof window.eatguudReapplySort === 'function') {
            window.eatguudReapplySort();
          }
        })
        .catch(function () {
          // leave data-next-url intact so a later intersection can retry
        })
        .finally(function () {
          loading = false;
          if (spinner) spinner.hidden = true;
        });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      },
      { rootMargin: '600px' }
    );

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
